import { v4 as uuidv4 } from "uuid";

const TOKEN = "token";
const ASSETS_LAST_MODIFIED = "assets-last-modified";

export const getAuthHeaders = async (): Promise<Record<string, string>> => {
  const headers: Record<string, string> = {
    authorization: "Bearer " + localStorage.getItem(TOKEN),
    "Content-Type": "application/json",
    clientRequestId: uuidv4(),
    [ASSETS_LAST_MODIFIED]:
      localStorage.getItem(ASSETS_LAST_MODIFIED) || "Not set",
  };

  try {
    const { default: oidcAuthService } = await import(
      "src/services/oidcAuthService"
    );
    const federateToken = await oidcAuthService.checkAndGetValidToken();
    if (federateToken) {
      headers["federate-authorization"] = "Bearer " + federateToken;
    }
  } catch (error) {
    // Continue without federate token if service is unavailable
  }

  return headers;
};
